module.exports = __webpack_public_path__ + "static/img/ROMAMA-MAPLE.dbcf234.png";


//////////////////
// WEBPACK FOOTER
// ./static/materials/cortina/ROMAMA-MAPLE.png
// module id = jkIE
// module chunks = 0